import MyAudioPlayer from "@/components/my-audio";
import { addMeetingRecord, endMeetingMinutes, submitMeetingRecordFile } from "@/declare/api/meeting";
import { MeetingAttendee, MeetingRecord } from "@/declare/interface/meeting";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as NextSvg } from "../icons/next.svg"
import { ReactComponent as StopSvg } from "../icons/stop.svg"
import { ReactComponent as WhitePlaySvg } from "../icons/white-play.svg"
import { ReactComponent as WhiteStopSvg } from "../icons/white-stop.svg"
import "./index.less"
import { MeetingMinuteStatus } from "@/declare/enums/meeting-minute-status";
import ReconnectingWebSocket from "reconnecting-websocket";
import Recorder from 'js-audio-recorder';
import { getWavBlobFromPcmBlob } from "@/utils/pcm-utils";
import { Tooltip, message } from "antd";
import genUUID from "@/utils/gen-uuid";

const MEETING_WS_TYPE = {
    START: "START",
    NEXT: "NEXT",
    STOP: "STOP",
}

const WsConfig = {
    // TODO: build 部署时要修改ws地址端口
    address: process.env.NODE_ENV === 'development' ?
        `ws://localhost:9803/pcm` :
        `wss://tools.tncet.com/pcm`,
}


const updateRegex = /^UPDATE_LAST---/;
interface MeetingMinuteRecordBottomProps {
    /**
     * 是否处于暂停状态
     */
    paused: boolean;
    /**
     * 设置暂停状态
     * @param paused 
     * @returns 
     */
    setPaused: (paused: boolean) => void;

    /**
     * 识别到语音变化后的回调
     * @param transcript 
     * @returns 
     */
    onTextChange?: (transcript: string) => void;

    /**
     * 点击结束按钮后的回调
     * @returns 
     */
    onEnd?: () => void;

    /**
     * 会议纪要状态
     */
    status: number
    /**
     * 音频url
     */
    soundUrl: string
    /**
     * 音频时长
     */
    soundDuration: number

    onReceiveChange: (record: MeetingRecord) => void

    addRecordItem: (record: MeetingRecord) => void

    /**
     * 当前选中的讲话人
     */
    activeAttendee: MeetingAttendee

}

let wsInterval;
export function MeetingMinuteRecordBottom(props: MeetingMinuteRecordBottomProps) {
    const { meetingId } = useParams();
    const meetingIdRef = useRef<string>(meetingId);

    const isInitRws = useRef<boolean>(false)

    const {
        setPaused,
        onTextChange,
        onEnd,
        onReceiveChange,
        addRecordItem,
        paused,
        status,
        soundUrl,
        soundDuration,
        activeAttendee
    } = props

    const [rws, setRws] = useState<ReconnectingWebSocket>(null);
    const [recorder, setRecorder] = useState<Recorder>(null);
    const transcriptRef = useRef<string>("");
    const [nowRecordingId, setNowRecordingId] = useState<number>(null);

    const [updateSpeakerUuid, setUpateSpeakerUuid] = useState<string>(genUUID());  // 记录触发切人的操作
    const [updateIntervalUuid, setUpateIntervalUuid] = useState<string>(null);  // 记录自动切人后的回调

    useEffect(() => {
        if (rws == null || meetingId == null || meetingId.length == 0) return;
        console.log("send", `RG${meetingId}MEETING`)
        rws.send(`RG${meetingId}MEETING`);
        const interval = setInterval(() => {
            console.log("send", `HB${meetingId}MEETING`)
            rws.send(`HB${meetingId}MEETING`);
        }, 10000)
        return () => {
            clearInterval(interval);
        }
    }, [meetingId, rws])

    /**
     * 初始化与后端通讯的websocket与监听语音输入的recorder
     * @returns 
     */
    const initRwsAndRecorder = () => {
        if (!meetingId) return
        console.log('WsConfig.address', WsConfig.address)
        let rws = new ReconnectingWebSocket(WsConfig.address);
        rws.binaryType = 'arraybuffer';
        rws.onerror = function (err) {
            console.error(err);
        };
        rws.onclose = function (msg) {
            console.info(msg);
        };

        rws.onopen = function () {
            setRws(rws)
        }
        let recorder = new Recorder({
            sampleBits: 16,                 // 采样位数，支持 8 或 16，默认是16
            sampleRate: 16000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，
            numChannels: 1,                 // 声道，支持 1 或 2， 默认是1
            compiling: true                 // 是否边录边转换，默认是false
        })
        setRecorder(recorder)
    }

    /**
     * 监听录制状态变化，若开始录制且页面没有初始化rws，则初始化interval开始发送语音包
     * 该useEffect只会执行一次
     */
    useEffect(() => {
        if (rws == null || recorder == null) return;
        if (!paused && !isInitRws.current) {
            if (rws.readyState === 1) { //ws进入连接状态，则每隔500毫秒发送一包数据
                let addData: MeetingRecord = {
                    meetingId: +meetingId,
                    userId: activeAttendee?.id,
                    name: activeAttendee?.name
                }
                addMeetingRecord(+meetingId, addData).then(res => {
                    addData.id = res.data
                    addRecordItem(addData)
                    setNowRecordingId(res.data)
                    recorder.start().then(() => {
                        // 开始录音
                        setPaused(false);
                        // 向后端发送信号，提示开始识别语音
                        rws.send(`${MEETING_WS_TYPE.START}${meetingId}MEETING`)

                        wsInterval = setInterval(() => {
                            const data = recorder.getNextData();
                            data.forEach(item => {
                                rws.send(item);
                            })
                        }, 1000)

                    }, (error) => {
                        console.log(`出错了 error:`, error);
                    });
                }).catch(e => {
                    message.error("添加记录失败！")
                })

            }
            isInitRws.current = true
        }

    }, [paused, rws, recorder])

    useEffect(() => {
        meetingIdRef.current = meetingId;
    }, [meetingId])

    useEffect(() => {
        if (!rws) return;
        rws.onmessage = function (msg) {
            let str = msg.data;
            if (updateRegex.test(str)) {
                let recordStr = str.split("---")[1];
                let record = JSON.parse(recordStr)
                onReceiveChange(record)
            } else {
                transcriptRef.current = str
                if (onTextChange) {
                    onTextChange(str)
                }
            }

        };
    }, [rws, onReceiveChange])


    /**
     * 点击开始|暂停录制
     * @returns 
     */
    const onClickUpdatePaused = () => {
        if (paused) {
            // 若是已经初始化过了，则直接开启录制即可
            if (isInitRws.current) {
                if (rws.readyState === 1) {
                    recorder.start().then(
                        () => {
                            setPaused(false);
                            // 向后端发送信号，提示开始识别语音
                            rws.send(`${MEETING_WS_TYPE.START}${meetingId}MEETING`)

                            wsInterval = setInterval(() => {
                                const data = recorder.getNextData();
                                data.forEach(item => {
                                    rws.send(item);
                                })
                            }, 1000)
                        },
                        (error) => {
                            console.log(`出错了 error:`, error);
                        }
                    );
                    let addData: MeetingRecord = {
                        meetingId: +meetingId,
                        userId: activeAttendee?.id,
                        name: activeAttendee?.name
                    }
                    addMeetingRecord(+meetingId, { meetingId: +meetingId }).then(res => {
                        addData.id = res.data
                        addRecordItem(addData)
                        setNowRecordingId(res.data)
                    }).catch(e => {
                        message.error("添加记录失败！")
                    })
                }
            } else {
                // 还未初始化，则需要初始化
                initRwsAndRecorder()
                setPaused(false)
            }
        } else {
            let pcmData = recorder.getPCMBlob()
            recorder.stop();
            getWavBlobFromPcmBlob(pcmData).then(res => {
                const { audioBlob, duration } = res
                uploadSound(pcmData, audioBlob, duration, nowRecordingId)
            })

            clearInterval(wsInterval)
            setPaused(true);
            // 向后端发送信号，提示本次连接的websocket已经结束
            rws.send(`${MEETING_WS_TYPE.STOP}${meetingId}MEETING`)
        }
    }

    /**
     * 点击下一个（切换）
     * @returns 
     */
    const myOnSpeakerChange = () => {
        if (paused) {
            return; //如果处于暂停状态，则不切换说话人
        }
        setUpateSpeakerUuid(genUUID());
        clearInterval(wsInterval)
        let pcmData = recorder.getPCMBlob()
        recorder.stop();
        recorder.start().then(() => {
            // 向后端发送信号，提示本次连接的websocket已经结束，需要进行下一段语音识别
            rws.send(`${MEETING_WS_TYPE.NEXT}${meetingId}MEETING`)

            wsInterval = setInterval(() => {
                const data = recorder.getNextData();
                data.forEach(item => {
                    rws.send(item);
                })
            }, 1000)
        }, (error) => {
            console.log("出错了 error:", error);
        })
        let addData: MeetingRecord = {
            meetingId: +meetingId,
            userId: activeAttendee?.id,
            name: activeAttendee?.name
        }
        addMeetingRecord(+meetingId, addData).then(res => {
            addData.id = res.data
            addRecordItem(addData)
            getWavBlobFromPcmBlob(pcmData).then(res => {
                const { audioBlob, duration } = res
                uploadSound(pcmData, audioBlob, duration, nowRecordingId)
            })
            setNowRecordingId(res.data)
        })
    }

    useEffect(() => {
        let i = setInterval(() => {
            setUpateIntervalUuid(genUUID());
        }, 25000)
        return (() => {
            clearInterval(i)
        })
    }, [rws, paused, meetingId, updateSpeakerUuid, activeAttendee])

    useEffect(() => {
        myOnSpeakerChange()
    }, [activeAttendee])

    useEffect(() => {
        if (updateIntervalUuid != null) {
            myOnSpeakerChange();
        }
    }, [updateIntervalUuid])

    /**
     * 点击结束会议
     */
    const myOnEnd = () => {
        let pcmData = recorder?.getPCMBlob()
        recorder?.stop();
        if (pcmData) {
            getWavBlobFromPcmBlob(pcmData).then(res => {
                const { audioBlob, duration } = res
                uploadSound(pcmData, audioBlob, duration, nowRecordingId)
            })
            setPaused(true);
            if (rws) {
                rws.close();
            }
            clearInterval(wsInterval);
        }
        if (onEnd) {
            onEnd();
        }
        rws.send(`${MEETING_WS_TYPE.STOP}${meetingId}MEETING`)
        setTimeout(() => {
            endMeetingMinutes(+meetingId);
        }, 500);
    }

    /**
     * 上传音频文件
     * @param audioBlob 
     * @param duration 
     */
    const uploadSound = (pcmBlob: Blob, wavBlob: Blob, duration: number, recordId: number) => {
        // 以下执行上传操作
        const newMeetingRecord: MeetingRecord = {
            meetingId: +meetingIdRef.current,
            text: transcriptRef.current,
            duration: duration,
        }
        submitMeetingRecordFile(recordId, pcmBlob, wavBlob, newMeetingRecord).then(res => {

        }).catch(e => {
            message.error("更新失败！")
        })
    }

    return (
        <div className="meeting-minutes-record-button-container">
            {[MeetingMinuteStatus.COMPLETED].includes(status) && (
                <>
                    <MyAudioPlayer
                        duration={soundDuration}
                        audioUrl={soundUrl}
                    />
                </>
            )}
            {[MeetingMinuteStatus.NOT_STARTED, MeetingMinuteStatus.RECORDING, MeetingMinuteStatus.PAUSED].includes(status) && (
                <>
                    <Tooltip title={paused ? "开始录音" : "暂停录音"}>
                        <div className="play" onClick={onClickUpdatePaused} >
                            {paused && <WhitePlaySvg className="play-icon" />}
                            {!paused && <WhiteStopSvg className="play-icon" />}
                        </div>
                    </Tooltip>
                    <Tooltip title="切换下一段">
                        <NextSvg className="icon" onClick={myOnSpeakerChange} />
                    </Tooltip>
                    <Tooltip title="结束会议，开始AI分析">
                        <StopSvg className="icon" onClick={myOnEnd} />
                    </Tooltip>
                </>
            )}
            {[MeetingMinuteStatus.ANALYSIS].includes(status) && (
                <span>分析中...</span>
            )}
        </div>

    )

}